"use strict";

($dt => {

	const { on_nothing, convert_egalaxy_date } = $dt.TopicGrid.Functions;

	/**
	 * Additional notes and form submit prevalidation.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i5 = (block, inner_screen, controller) => {
		// Additional notes collection
		const { inner_elem } = inner_screen;
		const [ button_next_elem, button_prev_elem, form_elem, selected_date_label, additional_notes_instructions_elem ] = [
			inner_elem.querySelector('.button-next'),
			inner_elem.querySelector('.button-prev'),
			inner_elem.querySelector('form'),
			inner_elem.querySelector('.selected-date'),
			inner_elem.querySelector('.additional-notes-instructions')
		];

		button_prev_elem.addEventListener('click', () => {
			const { current_screen, contact_info } = block;
			if (contact_info.anon) {
				current_screen.outer = 1;
				current_screen.inner = 0;
			} else {
				current_screen.outer = 0;
				current_screen.inner = 4;
			}
			controller.SetScreenUI(block);
		});

		inner_screen.Show = () => {
			const { scheduling_info, current_topic } = block;

			// Additional Notes
			additional_notes_instructions_elem.innerHTML = '';
			if (current_topic.additional_notes_text) {
				additional_notes_instructions_elem.innerHTML = current_topic.additional_notes_text;
			}

			// Set selected date label
			selected_date_label.innerHTML = convert_egalaxy_date(scheduling_info.selected_date) + ' at ' + scheduling_info.selected_time;
		};

		$dt.OnDevelformsReady($df => {
			$df.RegisterFormPreparedEvent('eglxyorder', form => {

				const validate_form_submit = () => {
					controller.StartWaiting(block);

					const { scheduling_info, d3df_page_options } = block;
					form.currentContainer = form_elem;

					// Form processing
					const data = $df.serialize(form_elem);

					// Contact Info if Anonymous
					controller.SetContactInfoFormData(block, data);

					// Known scheduling info for progressive form saving
					controller.SetSchedulingFormData(block, data);

					const on_success = () => {
						// Save contact info
						const { current_screen } = block;
						scheduling_info.notes = data.notes;

						// Transition Screen
						current_screen.outer = 0;
						current_screen.inner = 6;
						controller.SetScreenUI(block);
					};

					const on_validation_failed = errors => {
						controller.FormValidationFailed(form, errors);
					};

					const on_complete = () => {
						controller.EndWaiting(block);
					};

					// Update page options
					d3df_page_options.pageIndex = 1;
					d3df_page_options.onSuccess = on_success;

					// Validation only submission
					controller.ResetFormValidation(form);
					form.submit(data, on_success, on_validation_failed, on_nothing, on_complete, d3df_page_options);
				};

				button_next_elem.addEventListener('click', $dt.Util.debounce(validate_form_submit, $df.debounceThreshold));

				button_next_elem.removeAttribute('disabled');
			});
			
		});
	};

})(window.d3_wp_themejs);
